import React from 'react'
import * as S from './ClinicWrapper.styles'
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch'
import useClinicContext, { getClinic } from '../../store/ClinicContext'
import { Box } from '@mui/material'

const ClinicWrapper: React.FC = () => {
  const clinic = getClinic(useClinicContext())

  return (
    <S.Container>
      <S.GridContainer />
      <S.MainGridContainer>
        {clinic ? (
          <S.ClinicBanner>
            <S.NameLogo />
            <S.ClinicName>{clinic.name}</S.ClinicName>
          </S.ClinicBanner>
        ) : (
          <S.Logo />
        )}
      </S.MainGridContainer>
      <S.GridContainer>
        <S.RightItem>
          <Box>
            <LanguageSwitch />
          </Box>
        </S.RightItem>
      </S.GridContainer>
    </S.Container>
  )
}

export default ClinicWrapper
